import React from "react";
import PropTypes from "prop-types";

import "./RefundTextValue.sass";

function RefundTextValue({
  value,
  secondaryValue,
  className,
  secondaryClass,
  children,
}) {
  const hasPrimary =
    value !== null && value !== undefined && String(value).trim() !== "";
  const hasSecondary =
    secondaryValue !== null &&
    secondaryValue !== undefined &&
    String(secondaryValue).trim() !== "";

  return (
    <div className={`textValue ${className}`}>
      {hasPrimary && value}

      {hasSecondary && (
        <div className={`textValue__secondary ${secondaryClass}`}>
          {secondaryValue}
        </div>
      )}

      {children}
    </div>
  );
}

RefundTextValue.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  secondaryValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  secondaryClass: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

RefundTextValue.defaultProps = {
  value: "",
  secondaryValue: "",
  className: "",
  secondaryClass: "",
  children: null,
};

export default RefundTextValue;
